/*
* 点位采集汇总组件
* zxw
* 创建时间：2025-05-25
* 更新时间：2026-07-04
* 更新内容：优化下载进度条
*/

import { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    theme,
    Row,
    Col,
    Modal,
    Button,
    Image,
    message,
    Progress,
    Spin,
    Flex,
    Typography,
} from 'antd';
import {
    // Html2pdf,
    UjoinParams,
    AddRequestHeaders,
    defaultImage,
    AliyunOSSclient,
    Base64DataUrlToArrayBuffer,
    CurrentDate,
    winHeight,
} from '../../incs/FunHelper.js';
import { saveAs } from 'file-saver';
import docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import JSZipUtils from 'jszip-utils';
import ImageModule from 'docxtemplater-image-module-free' //这句是导出图片用的
import XZTLOGO from '../../images/logo-head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

const { Title, Paragraph } = Typography

// 表格列宽
const COLWIDTH = 40;
const PLCSummary = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [ulid, setUlid] = useState('');
    const [data, setData] = useState([]);
    const [fileILIPList, setFileILIPList] = useState([]);
    const [fileCELIPList, setFileCELIPList] = useState([]);

    const [showSize, setShowSize] = useState(CNF.pageSize); // 显示大小
    const [ossToken, setOssToken] = useState(null);
    // 用于记录上一次 data 的长度，判断数据是否变更
    const prevDataLengthRef = useRef(0);

    // 记录接口是否正在请求
    const [loadingAPI, setLoadingAPI] = useState(false);

    const [haveDoublePinyin, setHaveDoublePinyin] = useState(false); // 是否有双拼，目的是为了兼容旧版本

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
    }

    /**
     * 将数据转化便于写入word
     * @param {*} modal 
     * @returns 
    */
    async function toWordData(modal, retFileILIPList, retFileCELIPList) {
        const newData = [];

        for (let i = 0; i < data.length; i++) {
            const item = { ...data[i] }; // 拷贝，不修改原数据

            // 格式化数值字段（数量为 0 显示为空）
            item.high_ball = item.high_ball > 0 ? item.high_ball : '';
            item.double_cabins = item.double_cabins > 0 ? item.double_cabins : '';
            item.double_pinyin = item.double_pinyin > 0 ? item.double_pinyin : '';
            item.old_equipment = item.old_equipment > 0 ? item.old_equipment : '';
            item.vehicle_checkpoint = item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : '';

            // 拆分经纬度
            const parts = item.longitude_latitude?.replace(',', '，').split('，') || [];
            item.longitude = parts.length > 1 ? parts[0] : '';
            item.latitude = parts.length > 1 ? parts[1] : '';

            // 杆高 / 建议高度
            item.rod_height = item.installation_height
                ? item.installation_height
                : (item.rod_height > 0 ? item.rod_height + 'm' : '');

            // 臂长
            item.arm_length = item.arm_length || '';

            // ---- 获取安装位置图片 Base64 ----
            item.ILIPUrl = '';
            if (item.installation_location_image_path && retFileILIPList[i]?.url) {
                try {
                    const response = await fetch(retFileILIPList[i].url);
                    const blob = await response.blob();
                    const base64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                    item.ILIPUrl = `data:image/png;base64,${base64}`;
                } catch (e) {
                    console.error('安装位置图片获取失败', e);
                }
            }

            // ---- 获取取电位置图片 Base64 ----
            item.CELIPUrl = '';
            if (item.connect_electricity_location_image_path && retFileCELIPList[i]?.url) {
                try {
                    const response = await fetch(retFileCELIPList[i].url);
                    const blob = await response.blob();
                    const base64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                    item.CELIPUrl = `data:image/png;base64,${base64}`;
                } catch (e) {
                    console.error('取电位置图片获取失败', e);
                }
            }

            newData.push(item);

            // 更新进度（保留两位小数）
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress
                    percent={parseFloat(((i + 1) / data.length * 100)).toFixed(0)}
                    percentPosition={{ align: 'end', type: 'inner' }}
                    size={[400, 20]}
                    strokeColor={colorPrimary}
                />,
            }));
        }

        return newData;
    }

    /**
     * 下载图片
    */
    async function downloadImage(d, modal) {
        const retFileILIPList = [];
        const retFileCELIPList = [];

        for (let i = 0; i < d.length; i++) {
            const item = d[i];

            // ----- 安装位置图片 -----
            if (item.installation_location_image_path) {
                try {
                    const arr = item.installation_location_image_path.split('/');
                    const url = await AliyunOSSclient(ossToken).signatureUrl(
                        item.installation_location_image_path,
                        {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        }
                    );
                    retFileILIPList.push({
                        percent: 100,
                        url,
                        preview: url,
                        status: 'done',
                        path: item.installation_location_image_path,
                        name: arr[arr.length - 1],
                    });
                } catch {
                    retFileILIPList.push({ percent: 100, url: '', preview: '', status: 'done', path: '', name: '' });
                }
            } else {
                retFileILIPList.push({ percent: 100, url: '', preview: '', status: 'done', path: '', name: '' });
            }

            // ----- 取电位置图片 -----
            if (item.connect_electricity_location_image_path) {
                try {
                    const arr = item.connect_electricity_location_image_path.split('/');
                    const url = await AliyunOSSclient(ossToken).signatureUrl(
                        item.connect_electricity_location_image_path,
                        {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        }
                    );
                    retFileCELIPList.push({
                        percent: 100,
                        url,
                        preview: url,
                        status: 'done',
                        path: item.connect_electricity_location_image_path,
                        name: arr[arr.length - 1],
                    });
                } catch {
                    retFileCELIPList.push({ percent: 100, url: '', preview: '', status: 'done', path: '', name: '' });
                }
            } else {
                retFileCELIPList.push({ percent: 100, url: '', preview: '', status: 'done', path: '', name: '' });
            }

            // 更新进度
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress
                    percent={parseFloat(((i + 1) / d.length * 100)).toFixed(0)}
                    percentPosition={{ align: 'end', type: 'inner' }}
                    size={[400, 20]}
                    strokeColor={colorPrimary}
                />,
            }));
        }

        return { retFileILIPList, retFileCELIPList };
    }

    /**
     * 导出到word
    */
    const exportWord = (newData, modal) => {
        const record = props.record;
        let date = record.start_date ? record.start_date.split('-')[0] + '年' + record.start_date.split('-')[1] + '月' : '';

        const wordData = {
            projectName: record.name,
            affiliateUnit: record.affiliate_unit,
            date: date,
            plData: newData,
        };

        let templatePath = '/templates/PLCS.docx';
        if (record.export_template) {
            templatePath = '/templates/' + record.export_template;
        }

        // 加载模板
        JSZipUtils.getBinaryContent(templatePath, function (error, content) {
            // 模板加载失败处理
            if (error) {
                Modal.destroyAll();
                setLoading(false);
                messageApi.error('模板加载失败！', CNF.messageDuration);
                console.error('模板加载错误：', error);
                return;
            }

            // 配置图片模块
            const opts = { centered: false, fileType: 'docx' };
            opts.getImage = function (chartId) {
                return Base64DataUrlToArrayBuffer(chartId);
            };
            opts.getSize = function (img, tagValue, tagName) {
                return [550, 330];
            };
            const imageModule = new ImageModule(opts);

            // 创建 doc 实例
            const zip = new PizZip(content);
            const doc = new docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip)
                .setOptions({ paragraphLoop: true, linebreaks: true })
                .compile();

            doc.setData(wordData);

            // 渲染文档
            try {
                doc.render();
            } catch (renderError) {
                Modal.destroyAll();
                setLoading(false);
                messageApi.error('文档渲染失败！', CNF.messageDuration);
                console.error('渲染错误：', renderError);
                return;
            }

            // 生成 Blob
            const out = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });

            // 触发下载
            try {
                saveAs(out, record.name + '前端点位勘察表' + CurrentDate() + '.docx');
            } catch (saveError) {
                Modal.destroyAll();
                setLoading(false);
                messageApi.error('下载失败！', CNF.messageDuration);
                console.error('saveAs 错误：', saveError);
                return;
            }

            // ----- 下载成功后的处理（关键改动）-----
            // 1. 立即更新进度为 100%（覆盖之前进度）
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress
                    percent={100}
                    percentPosition={{ align: 'end', type: 'inner' }}
                    size={[400, 20]}
                    strokeColor={colorPrimary}
                />,
            }));

            // 2. **立即取消加载状态，让按钮恢复**
            setLoading(false);

            // 3. 显示成功消息
            messageApi.success('下载成功！', CNF.messageDuration);

            // 4. 延迟关闭弹窗，以便用户看到成功提示
            setTimeout(() => {
                Modal.destroyAll();   // 销毁所有 Modal
                cancel();             // 调用 cancel 关闭组件并重置状态（内部会再次 setLoading(false)，但无妨）
            }, CNF.messageDuration * 1000);
        });
    };

    /**
     * 下载
    */
    async function download() {
        // 下载期间禁止在此下载
        if (loading) return;
        setLoading(true);

        // 第一阶段：获取所有图片签名 URL
        const modal1 = Modal.info({
            title: '前端点位勘察信息表图片初始化···',
            icon: null,
            content: <Progress
                percent={0}
                percentPosition={{ align: 'end', type: 'inner' }}
                size={[400, 20]}
                strokeColor={colorPrimary}
            />,
            footer: null,
            keyboard: false,
        });
        let { retFileILIPList, retFileCELIPList } = await downloadImage(data, modal1);
        modal1.destroy();

        // 第二阶段：下载并生成 Word
        const modal2 = Modal.info({
            title: '前端点位勘察信息表正在下载中···',
            icon: null,
            content: <Progress
                percent={0}
                percentPosition={{ align: 'end', type: 'inner' }}
                size={[400, 20]}
                strokeColor={colorPrimary}
            />,
            footer: null,
            keyboard: false,
        });
        let newData = await toWordData(modal2, retFileILIPList, retFileCELIPList);
        exportWord(newData, modal2);
    }

    // 获取数据
    useEffect(() => {
        setLoadingAPI(true);
        setUlid(props.record.key);
        /**
         * 获取列表
         */
        const getData = () => {
            const params = {
                'collect_ulid': props.record.key,
                'status': CNF.status[0].value,
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}pointLocations/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setHaveDoublePinyin(data.dat.some(item => item.double_pinyin > 0));
                            setData(data.dat);
                        } else {
                            setData([]);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
                .always(() => setLoadingAPI(false))
        }
        if (props.record && props.record.key !== ulid) {
            getData();
        }
    }, [props.record, ulid, data, messageApi]);

    // 1. 获取 OSS Token 的 useEffect（保持不变）
    useEffect(() => {
        if (data.length > 0 && !ossToken) {
            const params = { 'acl': 'GetObject' };
            $.ajax({
                url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                headers: AddRequestHeaders(),
                type: 'GET',
                success: function (data) {
                    if (data.res === 0) {
                        setOssToken(data.dat);
                    }
                }
            });
        }
    }, [data, ossToken]);

    // 2. 加载图片的 useEffect（监听 data、showSize、ossToken）
    useEffect(() => {
        // 当 data 长度变化时，重置图片列表（清空旧数据）
        if (data.length !== prevDataLengthRef.current) {
            setFileILIPList([]);
            setFileCELIPList([]);
            prevDataLengthRef.current = data.length;
            // 如果 data 为空，直接返回
            if (data.length === 0) return;
        }

        // 若 token 未就绪或无数据，暂不处理
        if (!ossToken || data.length === 0) return;

        // 补充加载图片（只处理前 showSize 项）
        const loadImages = () => {
            // 更新安装位置图片列表
            setFileILIPList(prevList => {
                const newList = [...prevList];
                // 确保列表长度至少为 data.length，避免访问越界
                if (newList.length < data.length) {
                    newList.length = data.length;
                }
                // 遍历前 showSize 项，补全缺失的 URL
                for (let i = 0; i < Math.min(showSize, data.length); i++) {
                    const item = data[i];
                    // 如果当前项已有 URL 或没有图片路径，则跳过
                    if (newList[i]?.url || !item?.installation_location_image_path) {
                        continue;
                    }
                    // 生成签名 URL
                    const arr = item.installation_location_image_path.split('/');
                    const url = AliyunOSSclient(ossToken).signatureUrl(
                        item.installation_location_image_path,
                        {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        }
                    );
                    newList[i] = {
                        percent: 100,
                        url,
                        preview: url,
                        status: 'done',
                        path: item.installation_location_image_path,
                        name: arr[arr.length - 1],
                    };
                }
                return newList;
            });

            // 更新取电位置图片列表
            setFileCELIPList(prevList => {
                const newList = [...prevList];
                if (newList.length < data.length) {
                    newList.length = data.length;
                }
                for (let i = 0; i < Math.min(showSize, data.length); i++) {
                    const item = data[i];
                    if (newList[i]?.url || !item?.connect_electricity_location_image_path) {
                        continue;
                    }
                    const arr = item.connect_electricity_location_image_path.split('/');
                    const url = AliyunOSSclient(ossToken).signatureUrl(
                        item.connect_electricity_location_image_path,
                        {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                            }
                        }
                    );
                    newList[i] = {
                        percent: 100,
                        url,
                        preview: url,
                        status: 'done',
                        path: item.connect_electricity_location_image_path,
                        name: arr[arr.length - 1],
                    };
                }
                return newList;
            });
        };

        loadImages();
    }, [data, showSize, ossToken]);

    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                closable={false}
                open={props.open}
                keyboard={true}
                width={1060}
                height={winHeight}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='link'
                        type='primary'
                        onClick={download}
                        loading={loading}
                        style={{ marginRight: '24px' }}>{loading ? '下载中···' : '下载'}</Button>,
                ]}
            >
                <div id='printer-summary-info-id'>
                    <div className='print-info'
                        style={{
                            padding: '0 30px',
                            width: 960,
                            height: winHeight - 84,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                        }}
                        onScroll={(e) => {
                            let scrollHeight = e.target.scrollHeight;  // 滚动高度
                            let clientHeight = e.target.clientHeight;  // 可见高度
                            let scrollTop = e.target.scrollTop;        // 滚动条离顶部的高度
                            if (scrollHeight - scrollTop <= clientHeight + 5) { // 滚动条到底部，逐步显示更多数据
                                setShowSize(showSize + CNF.pageSize);
                            }
                        }}
                    >
                        <Flex vertical align='center'>
                            <Flex justify='space-between' style={{ width: '100%' }}>
                                <Image src={XZTLOGO} height={'45px'} alt={CNF.companyShortName} />
                                <Image src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} />
                            </Flex>
                            <Title level={2}>{props.record.name}</Title>
                            <Title level={4} style={{ margin: '100px 0' }}>前端点位勘察信息表</Title>
                            <Paragraph style={{ margin: 0 }}>{props.record.affiliate_unit}</Paragraph>
                            <Paragraph style={{ margin: 0 }}>
                                {props.record.start_date ? props.record.start_date.split('-')[0] + '年' : ''}
                                {props.record.start_date ? props.record.start_date.split('-')[1] + '月' : ''}
                            </Paragraph>
                            <Title level={4}>前端点位勘察信息表</Title>
                        </Flex>
                        <table width='100%'>
                            <tbody>
                                <tr style={{ background: '#D7D7D7', fontWeight: 'bold' }}>
                                    <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center' }}>点位编号</td>
                                    <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center' }}>所属辖区</td>
                                    <td colSpan='7' rowSpan='2' style={{ width: COLWIDTH * 6, textAlign: 'center' }}>点位名称</td>
                                    <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center' }}>一杆几机</td>
                                    <td colSpan='4' style={{ width: COLWIDTH * 4, textAlign: 'center' }} >机型</td>
                                    <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center' }}>杆件类型</td>
                                    <td colSpan='7' rowSpan='2' style={{ width: COLWIDTH * 7, textAlign: 'center' }}>经纬度</td>
                                </tr>
                                <tr style={{ background: '#D7D7D7', fontWeight: 'bold' }}>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>球机</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>双舱</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>{haveDoublePinyin ? '双拼' : '利旧'}</td>
                                    <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center' }}>大卡</td>
                                </tr>
                                {
                                    data && data.map((item, index) => {
                                        return <tr key={index}>
                                            <td colSpan='2' style={{ width: COLWIDTH * 2, }}>{item.number}</td>
                                            <td colSpan='2' style={{ width: COLWIDTH * 2, }}>{item.police_station}</td>
                                            <td colSpan='7' style={{ width: COLWIDTH * 6, }}>{item.name}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.rod_device_count}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.high_ball > 0 ? item.high_ball : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.double_cabins > 0 ? item.double_cabins : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{
                                                haveDoublePinyin ? (item.double_pinyin > 0 ? item.double_pinyin : '') : (item.old_equipment > 0 ? item.old_equipment : '')
                                            }</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : ''}</td>
                                            <td colSpan='1' style={{ width: COLWIDTH, }}>{item.installation_method}</td>
                                            <td colSpan='7' style={{ width: COLWIDTH * 7, }}>{item.longitude_latitude}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        {
                            data.length === 0 && loadingAPI && <Spin description='加载中...'><div style={{ height: 100 }}></div></Spin>
                        }
                        {
                            data && data.map((item, index) => {
                                if (index >= showSize) return null;
                                return <div key={index}>
                                    <Row style={{ marginTop: '50px' }} justify='center'> <Col><h2>{props.record.name}前端点位勘察信息表</h2></Col></Row>
                                    <table width='100%'>
                                        <tbody>
                                            <tr>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>编号</td>
                                                <td colSpan='3' rowSpan='2' style={{ width: COLWIDTH * 3, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>点位<br />名称</td>
                                                <td colSpan='3' rowSpan='2' style={{ width: COLWIDTH * 3, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>点位详细地址</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>所属<br />辖区</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>杆型</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>杆高/建议高度</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>臂长</td>
                                                <td colSpan='1' rowSpan='2' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>一杆<br />几机</td>
                                                <td colSpan='4' style={{ width: COLWIDTH * 4, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>摄像机类型</td>
                                                <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>防控<br />区域</td>
                                                <td colSpan='2' rowSpan='2' style={{ width: COLWIDTH * 2, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>取电<br />位置</td>
                                                <td colSpan='4' rowSpan='2' style={{ width: COLWIDTH * 4, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>经纬度</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>球机</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>双舱</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{haveDoublePinyin ? '双拼' : '利旧'}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, textAlign: 'center', wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>大卡</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.number}</td>
                                                <td colSpan='3' style={{ width: COLWIDTH * 3, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.name}</td>
                                                <td colSpan='3' style={{ width: COLWIDTH * 3, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.address}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.police_station}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.installation_method}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.installation_height ? item.installation_height : (item.rod_height > 0 ? item.rod_height + 'm' : item.installation_height > 0 ? '≥' + item.installation_height + 'm' : '')}</td>
                                                < td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.arm_length ? item.arm_length : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.rod_device_count}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.high_ball > 0 ? item.high_ball : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.double_cabins > 0 ? item.double_cabins : ''}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{
                                                    haveDoublePinyin ? (item.double_pinyin > 0 ? item.double_pinyin : '') : (item.old_equipment > 0 ? item.old_equipment : '')}</td>
                                                <td colSpan='1' style={{ width: COLWIDTH, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.vehicle_checkpoint > 0 ? item.vehicle_checkpoint : ''}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.control_area}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.connect_electricity_location}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[0] : ''}</td>
                                                <td colSpan='2' style={{ width: COLWIDTH * 2, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>{item.longitude_latitude && item.longitude_latitude.replace(',', '，').split('，').length > 1 ? item.longitude_latitude.replace(',', '，').split('，')[1] : ''}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>安装位置：</td>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>取电位置：</td>
                                            </tr>
                                            <tr>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, height: 252, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    <Image
                                                        alt='安装位置'
                                                        width='100%'
                                                        src={item.installation_location_image_path && fileILIPList[index]?.url ? fileILIPList[index].url : null}
                                                        style={{ verticalAlign: 'top', maxWidth: '100%', height: '100%', aspectRatio: 5 / 3 }}
                                                        fallback={defaultImage}
                                                    />
                                                </td>
                                                <td colSpan='12' style={{ width: COLWIDTH * 12, height: 252, wordWrap: 'break-word', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    <Image
                                                        alt='取电位置'
                                                        width='100%'
                                                        src={item.connect_electricity_location_image_path && fileCELIPList[index]?.url ? fileCELIPList[index]?.url : null}
                                                        style={{ verticalAlign: 'top', maxWidth: '100%', height: '100%', aspectRatio: 5 / 3.1 }}
                                                        fallback={defaultImage}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            })
                        }
                    </div>
                </div>
            </Modal >
        </>
    );
}

export default PLCSummary;